<div class="userSettingPages" style="margin-top: 15px">
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"></ng-container>
    <ng-container *ngSwitchDefault>
      <div class="document-upload-main-container text" *ngIf="!hasInsicToken">
        <div class="document-info-text">
          {{ 'errorinsictoken' | t }}
        </div>
      </div>
      <div id="___avs-wrapper" style="height: 516px"></div>
    </ng-container>
  </ng-container>
</div>
